import { Badge } from "@similarweb/ui-components";

import type { IAiTrackerCampaign } from "app/pages/digital-marketing/generative-ai/llm-tracker/shared/types";

import { BrandsIndicatorComponent } from "./BrandsIndicatorComponent";

export const BrandsBadge = ({ campaign }: { campaign?: IAiTrackerCampaign }) => {
    const brands = campaign?.brands;
    if (!brands || brands.length === 0) {
        return null;
    }
    return (
        <BrandsIndicatorComponent
            brands={brands}
            placement="bottom"
        >
            <Badge
                type="neutral"
                shouldTransformTextToUpperCase={false}
            >
                {brands[0]}
            </Badge>
        </BrandsIndicatorComponent>
    );
};
